import { sendRequest, sendGoogleEvent } from '@html/_common/utils';
import AMCommonQuantity from '@atomic/molecules/_common/quantity/quantity';

export default class AOTravelAgentContactForm {
  constructor(tourId) {
    this.eventCategory = 'Contact my Agent';
    this.TEMPLATE_ENDPOINT = '/api/popup/travel-agent';

    this.selectors = {
      wrapper: '.js-ao-common-agent-contact-form__overlay',
      container: '.js-ao-common-agent-contact-form__overlay--form',
      close: '.js-ao-common-agent-contact-form-popup__close--form',
      contactAgentButton: '.js-ao-tour-above-fold__contact-agent-button',
      formContent: '.js-ao-common-agent-contact-form',
      form: '.js-ao-common-agent-contact-form__form',
    };

    this.tourId = tourId;
    this.loading = false;
  }

  static getTriggerSelector() {
    return '.js-ao-tour-above-fold__contact-agent-button';
  }

  init() {
    this.loadPopup({
      successCallback: () => {
        this.bindButtons();
        // Pax
        new AMCommonQuantity().initiate('js-ao-common-agent-contact-form__adults');
        new AMCommonQuantity().initiate('js-ao-common-agent-contact-form__children');
        this.bindGAEvents();
      },
      errorCallback: () => {
        $(AOTravelAgentContactForm.getTriggerSelector()).remove();
      },
    });
  }

  loadPopup({ successCallback, errorCallback }) {
    this.loading = true;
    sendRequest(this.TEMPLATE_ENDPOINT, {
      action: 'contactAgent',
      tourId: this.tourId,
    }, (data) => {
      if (data.status === 'OK') {
        $('main').append(data.component);
        successCallback();
      } else {
        errorCallback();
      }
      this.loading = false;
    }, { dataType: 'json', type: 'POST' }, errorCallback);
  }

  gaEvent(action, label, params) {
    sendGoogleEvent(this.eventCategory, action, label, params);
  }

  togglePopup(toggle, screen = 'form') {
    $('html, body').toggleClass('layer', toggle);
    $(`${this.selectors.wrapper}--${screen}`).toggleClass('hid', !toggle);
  }

  bindButtons() {
    this.bindOpenButton();
    this.bindCloseButtons();
    this.bindSubmitForm();
  }

  bindCloseButtons() {
    $('body').on('click', this.selectors.close, () => {
      this.togglePopup(false);
      this.gaEvent(
        'Contact Form Closed',
        '',
        { ampEventName: 'share_link_contact_agent_form_closed' },
      );
    });

    $('body').on('click', '.js-ao-common-agent-contact-form-popup__close--success, .js-aa-btn--okay', () => {
      this.togglePopup(false, 'success');
    });
  }

  bindOpenButton() {
    $('body').on('click', this.selectors.contactAgentButton, () => {
      if (this.loading || !$(this.selectors.container).length) {
        return;
      }
      this.togglePopup(true);
      this.gaEvent(
        'Contact Button Clicked',
        '',
        { ampEventName: 'share_link_contact_agent_button_clicked' },
      );
    });
  }

  bindSubmitForm() {
    $(this.selectors.form).on('submit', (event) => {
      event.preventDefault();
      this.handleFormSubmit();
    });
  }

  bindGAEvents() {
    const $form = $(this.selectors.form);
    const $paxInput = $form.find('input[name=pax]');
    const $childrenInput = $form.find('input[name=children]');
    const $dateInput = $form.find('select[name=date]');

    $form.find('[name=name]').on('blur', (event) => {
      if (event.target.value) {
        this.gaEvent(
          'Name entered',
          '',
          { ampEventName: 'share_link_contact_agent_form_name_entered' },
        );
      }
    });
    $form.find('[name=email]').on('blur', (event) => {
      if (event.target.value) {
        this.gaEvent(
          'Email entered',
          '',
          { ampEventName: 'share_link_contact_agent_form_email_entered' },
        );
      }
    });
    $dateInput.on('change', (event) => {
      if (event.target.value) {
        this.gaEvent(
          'Dates selected',
          '',
          { ampEventName: 'share_link_contact_agent_form_date_selected' },
        );
      }
    });
    $paxInput.on('change', () => {
      this.gaEvent(
        'Pax Adults modified',
        $paxInput.val(),
        { ampEventName: 'share_link_contact_agent_form_pax_adults_modified' },
      );
    });
    $childrenInput.on('change', () => {
      this.gaEvent(
        'Pax Children modified',
        $childrenInput.val(),
        { ampEventName: 'share_link_contact_agent_form_pax_children_modified' },
      );
    });
    $form.find('[name=message]').on('blur', (event) => {
      if (event.target.value) {
        this.gaEvent(
          'Message text entered',
          '',
          { ampEventName: 'share_link_contact_agent_form_message_entered' },
        );
      }
    });
  }

  isFieldValid($field, validationFn = ((val) => !!val)) {
    const $theWrapper = $field.closest('.am-input');
    const errorClass = 'am-input--error';

    if (validationFn($.trim($field.val()))) {
      return !!$theWrapper.removeClass(errorClass);
    }

    $field
      .on('change paste keyup', () => {
        if (validationFn($field.val())) {
          $theWrapper.removeClass(errorClass);
        }
      });

    this.gaEvent('Form submitted fields missing');
    return !$theWrapper.addClass(errorClass);
  }

  validateForm($form, fieldsToValidate) {
    return fieldsToValidate.reduce(
      (acc, [fieldName, validationFn]) => {
        const isValid = this.isFieldValid($form.find(`[name=${fieldName}]`), validationFn);
        return acc && isValid;
      },
      true,
    );
  }

  handleFormSubmit() {
    const $form = $(this.selectors.form);
    const name = $form.find('[name=name]').val();
    const email = $form.find('[name=email]').val();
    const date = $form.find('select[name=date]').val();
    const numberOfAdultTravellers = parseInt($form.find('input[name=pax]').val(), 10) || 1;
    const numberOfChildrenTravellers = parseInt($form.find('input[name=children]').val(), 10) || 0;
    const message = $form.find('[name=message]').val();

    const $submitButton = $('#agent_contact_popup .js-aa-btn--submit');

    const fieldsToValidate = [
      ['name'],
      ['email'],
      ['message'],
    ];

    const isFormValid = this.validateForm($form, fieldsToValidate);

    if (!isFormValid) {
      alert($(this.selectors.formContent).data('validation-failed')); // eslint-disable-line
      return;
    }

    const data = {
      name,
      email,
      ...(date && date !== '0' && { date_start: date }),
      pax: numberOfAdultTravellers,
      pax_children: numberOfChildrenTravellers,
      message,
      tour_id: this.tourId,
      token: window.csrf,
    };

    $submitButton.attr('disabled', true);

    const errorMessage = $(this.selectors.formContent).data('request-failed');
    const action = $form.attr('action');
    sendRequest(action, data, (responseData) => {
      $submitButton.removeAttr('disabled');

      if (!responseData.success) {
        // eslint-disable-next-line no-alert
        alert(errorMessage);
        return false;
      }

      this.togglePopup(false);
      this.togglePopup(true, 'success');
      this.gaEvent(
        'Contact Form Submitted',
        '',
        { ampEventName: 'share_link_contact_agent_form_submitted' },
      );
      return true;
    }, {}, () => {
      $submitButton.removeAttr('disabled');
      // eslint-disable-next-line no-alert
      alert(errorMessage);
    });
  }
}
